import Typography from '@material-ui/core/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '../Button';
import messages from './messages';
import useStyles from './styles';

export interface FileUploadButtonProps {
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#Unique_file_type_specifiers
  fileType?: string;
  handleChange: () => React.ChangeEventHandler<HTMLInputElement>;
  fileName: string;
  error: string;
}

const FileUploadButton = ({
  fileType = 'image/*',
  handleChange,
  fileName,
  error,
  ...inputProps
}: FileUploadButtonProps) => {
  const classes = useStyles();

  return (
    <>
      <input
        accept={fileType}
        id="file-upload-button"
        onChange={handleChange}
        style={{ display: 'none' }}
        type="file"
        {...inputProps}
      />
      <label className={classes.label} htmlFor="file-upload-button">
        <Button className={classes.button} component="span" size="small" type="secondary">
          <FormattedMessage {...messages.chooseFile} />
        </Button>
        <Typography
          className={classes.fileName}
          color={fileName ? 'textPrimary' : 'textSecondary'}
          noWrap
          title={fileName}
          variant="body2"
        >
          {fileName || <FormattedMessage {...messages.emptyState} />}
        </Typography>
      </label>
      {error && (
        <Typography className={classes.error} color="error" variant="body2">
          {error}
        </Typography>
      )}
    </>
  );
};

export default FileUploadButton;
